import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const SolutionsSection = () => {
  const solutions = [
    {
      title: 'Soins respiratoires & Cardiologie',
      description: 'Équipements de pointe pour les soins respiratoires et le monitoring cardiaque',
      image: 'https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/89ca3e627d03009a06bc6cad76fec729.jpeg',
      icon: 'ri-heart-pulse-line',
    },
    {
      title: 'Monitoring cardiaque',
      description: 'Solutions de surveillance et diagnostic cardiovasculaire',
      image: 'https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/cd4c3ed51c769ff7826cbef2547c4dab.jpeg',
      icon: 'ri-heart-line',
    },
    {
      title: 'Équipements hospitaliers',
      description: 'Matériel médical professionnel pour établissements de santé',
      image: 'https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/ceb286df058710132310fbc74b74ac3b.jpeg',
      icon: 'ri-hospital-line',
    },
    {
      title: 'Équipements de diagnostic',
      description: 'Technologies avancées pour un diagnostic précis et fiable',
      image: 'https://static.readdy.ai/image/3e6f353e8dbbec4f9360c3b978f4989c/649d0d35dd4c2e8319838079604dbb3d.png',
      icon: 'ri-stethoscope-line',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-4">
            Nos solutions médicales
          </h2>
          <p className="text-base md:text-lg text-[#4A4A4A] max-w-3xl mx-auto px-4">
            Des solutions complètes pour répondre aux besoins des établissements de santé
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
          {solutions.map((solution, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
            >
              <Link
                to="/solutions"
                className="block bg-[#1A1A1A] rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                <div className="relative h-48 sm:h-56 md:h-64 w-full overflow-hidden">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>
                <div className="p-6 md:p-8">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#E31B23] rounded-lg mb-4">
                    <i className={`${solution.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-3">
                    {solution.title}
                  </h3>
                  <p className="text-sm md:text-base text-white/80 leading-relaxed">
                    {solution.description}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
